import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceAuto } from '@services/ServiceAuto';
import { listYear } from '@services/ServiceAuto/TypePromise';
import { AxiosBase, handleError, handleResponse } from '@services/SettingAxios';
import { TypeResponseDisksFilters, TypeResponseTyresFilters } from '@models/Filter/mainFilte';
import { AkbFilterReturnPromise } from '@services/ServiceCatalog/TypePromise';

export const fetchAutoMark = createAsyncThunk<any[]>('mainFilter/fetchAutoMark', async () => {
  return await ServiceAuto.getAutoMarkFilter();
});

export const fetchAutoModel = createAsyncThunk<any[], number>('mainFilter/fetchAutoModel', async Id => {
  return await ServiceAuto.getAutoModelFilter(Id);
});

export const fetchAutoYears = createAsyncThunk<listYear[], { GroupCode: string; markId: number }>(
  'mainFilter/fetchAutoYears',
  async ({ GroupCode, markId }) => {
    return await ServiceAuto.getAutoYearFilter(GroupCode, markId);
  },
);

export const fetchAutoModification = createAsyncThunk<any[], number[]>('mainFilter/fetchAutoModification', async modelsId => {
  return await ServiceAuto.getAutoModificationFilter(modelsId);
});

export const fetchDiscsData = createAsyncThunk<TypeResponseDisksFilters, any>('mainFilter/fetchDiscsData', async params => {
  return await AxiosBase.post('/api/catalog/get-disks-filter', { params }).then(handleResponse).catch(handleError);
});

export const fetchTyresData = createAsyncThunk<TypeResponseTyresFilters>('mainFilter/fetchTyresData', async () => {
  return await AxiosBase.post('/api/catalog/get-tyres-filter').then(handleResponse).catch(handleError);
});

export const fetchAkbData = createAsyncThunk<AkbFilterReturnPromise, number>('mainFilter/fetchAkbData', async regionId => {
  return await AxiosBase.get(`/api/akb/filter?regionId=${regionId}`).then(handleResponse).catch(handleError);
});
